import ChangeSignInByPushNotificationComponent from './ChangeSignInByPushNotificationContainer';

export  default ChangeSignInByPushNotificationComponent ;